import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuperAdminStatusTag = () => /*#__PURE__*/_jsx(Tag, {
  inline: true,
  marginInlineStart: "200",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.superAdmin"
  })
});